export const MAX_VISIBLE_THUMBNAILS = 6;
